import Vue from "vue";
import Router from "vue-router";
import Home from "../src/pages/Home/Page-Home.vue";
import Login from "../src/pages/Login/Page-Login.vue"
import GeneralCourse from "../src/pages/Course/Page-GeneralCourse.vue";
import Contract from "../src/pages/Contract/Page-Contract.vue";
import GeneralUser from "../src/pages/User/Page-GeneralUser.vue";
import Registration from "../src/pages/Registration/Page-Registration.vue";
import Student from "../src/pages/Student/Page-Student.vue";
import Financer from "../src/pages/Financer/Page-Financer.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: Login,
  },
  {
    path: "/home",
    component: Home,
    name: "home",
    meta: {
      auth: true,
    },
  },
  {
    path: "/cursos",
    component: GeneralCourse,
    name: "cursos",
    meta: {
      auth: true
    }
  },
  {
    path: "/usuarios",
    component: GeneralUser,
    name: "usuarios",
    meta: {
      auth: true
    }
  },
 {
    path: "/contrato",
    component: Contract,
    name: "contrato",
    meta: {
      auth: true
    }
  }, 
 {
    path: "/matricula",
    component: Registration,
    name: "matricula",
    meta: {
      auth: true
    }
  }, 
 {
    path: "/alunos",
    component: Student,
    name: "alunos",
    meta: {
      auth: true
    }
  }, 
 {
    path: "/financeiro",
    component: Financer,
    name: "financeiro",
    meta: {
      auth: true
    }
  }, 
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "home" },
  },
];
const router = new Router({
  mode: "history",
  routes,
});

export default router;
